import React, { useEffect } from "react";

export interface TabInfo {
  id: string;
  name: string;
}

interface IProps {
  tabsInfo?: TabInfo[];
  defaultActiveTabId?: string;
  activeTabId?: string; // Add this prop for external control
  onClickTab: (tabId: string) => void;
}

const Button = ({
  id,
  name,
  isActive,
  onClick,
}: {
  id?: string;
  name: string;
  isActive?: boolean;
  onClick: () => void;
}) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "32px",
        height: "32px",
        color: "#FFFFFF",
        cursor: "pointer",
        fontSize: "12px",
        fontWeight: 700,
        background: isActive ? "#4A90F7" : "#9D9D9D",
      }}
      onClick={onClick}
    >
      {name}
    </div>
  );
};

const ActiveTabPicker = (props: IProps) => {
  const { defaultActiveTabId, tabsInfo, onClickTab, activeTabId } = props;

  const [currentActiveTab, setCurrentActiveTab] = React.useState<string>("");

  const handleTabClick = (tabId: string) => {
    // Only update internal state if activeTabId is not provided (uncontrolled mode)
    if (activeTabId === undefined) {
      setCurrentActiveTab(tabId);
    }
    onClickTab && onClickTab(tabId);
  };

  useEffect(() => {
    // If activeTabId is provided, use it (controlled mode)
    if (activeTabId !== undefined) {
      setCurrentActiveTab(activeTabId);
      return;
    }

    // Uncontrolled mode - use internal state logic
    if (currentActiveTab) return;

    if (defaultActiveTabId) {
      setCurrentActiveTab(defaultActiveTabId);
    }

    if (!defaultActiveTabId && tabsInfo?.length) {
      setCurrentActiveTab(tabsInfo[0].id);
    }
  }, [currentActiveTab, tabsInfo, defaultActiveTabId, activeTabId]);

  return (
    <div
      style={{
        display: "flex",
        overflow: "hidden",
        width: "100%",
        borderRadius: "8px",
      }}
    >
      {tabsInfo?.map((tabInfo) => (
        <Button
          key={tabInfo.id}
          id={tabInfo.id}
          name={tabInfo.name}
          isActive={currentActiveTab === tabInfo.id}
          onClick={() => handleTabClick(tabInfo.id)}
        />
      ))}
    </div>
  );
};

export default ActiveTabPicker;
